import React from 'react'
import Link from 'components/link'

export default function Logo({ className, style, black }){
    return(
        <Link to='/' className={className} style={style}>
            {black ? <img src='/svgs/inmusic-logo-black.svg' /> :
                <img src='/svgs/inmusic-logo-white.svg' />}
        </Link>
    )
}
